import { CustomElement } from "../../core/CustomElement";

export class CCCPanel extends CustomElement {
  static get observedAttributes(): Array<string> {
    return [
      "title",
      "background-color",
      "padding-vertical",
      "padding-horizontal",
    ];
  }

  constructor() {
    super();
    this.templateConfig = {
      template: require("./panel.html").default,
      style: require("./panel.scss").default,
    };
    this.setupComponent();
  }

  attributeChangedCallback(
    attr: string,
    oldValue: string | null,
    newValue: string | null
  ): void {
    const $component: HTMLElement = this.shadowDom.querySelector(".component");
    switch (attr) {
      case "title": {
        if (newValue) {
          this.shadowDom.querySelector(".title").innerHTML = newValue;
          this.shadowDom.querySelector(".title").classList.remove("hidden");
        } else {
          this.shadowDom.querySelector(".title").classList.add("hidden");
        }
        break;
      }
      case "background-color": {
        $component.style.backgroundColor = newValue;
        break;
      }
      case "padding-vertical": {
        $component.style.paddingTop = newValue;
        $component.style.paddingBottom = newValue;
        break;
      }
      case "padding-horizontal": {
        $component.style.paddingRight = newValue;
        $component.style.paddingLeft = newValue;
        break;
      }
    }
  }
}

// Define component.
if (!customElements.get("ccc-panel")) {
  customElements.define("ccc-panel", CCCPanel);
}
